export default {
  arca: {
    menuItem: "ARCA — E-invoicing",
    title: "ARCA",
    subtitle: "Connection with ARCA (Argentina) for electronic invoicing",
    notInvoicingYet:
      "This stage sets up the connection with ARCA. Invoices are not issued from the app yet.",
    environment: "Environment",
    envHomologacion: "Testing",
    envProduccion: "Production",
    envHomologacionHint: "Testing: nothing done here has fiscal validity.",
    envProduccionHint: "Live: documents have fiscal validity.",
    statusConnected: "Connected",
    statusPending: "Setup pending",
    statusError: "With errors",
    next: "Next",
    back: "Back",
    stepDone: "Done",
    steps: {
      fiscal: "Tax details",
      certificate: "Digital certificate",
      authorize: "Authorize in ARCA",
      sync: "Connect and sync",
    },
    fiscal: {
      intro:
        "The details of the taxpayer who will invoice, exactly as registered in ARCA.",
      cuit: "CUIT",
      cuitInvalid: "The CUIT is not valid (check digit mismatch).",
      razonSocial: "Legal name",
      condicionIva: "VAT status",
      choose: "Choose…",
      responsable_inscripto: "Registered VAT taxpayer",
      monotributo: "Monotributo",
      exento: "Exempt",
      domicilioComercial: "Business address",
      ingresosBrutos: "Gross income tax number",
      inicioActividades: "Start of activities",
      invoiceTypes: "What you will invoice",
      wsfe: "Domestic market",
      wsfeHint: "Invoices {types} (WSFE service).",
      wsfeHintNoIva:
        "Invoices A, B or C depending on your VAT status (WSFE service).",
      wsfex: "Export",
      wsfexHint: "Invoice E (WSFEX service). Needs its own point of sale.",
      puntoVenta: "Point of sale",
      puntoVentaExportacion: "Export point of sale",
      puntoVentaHint:
        "The web-services point of sale number you will use (or create) in ARCA.",
      certLockedCuit: "To change the CUIT, remove the certificates first.",
    },
    cert: {
      intro:
        "ARCA identifies the app with a digital certificate. We generate the key (stored encrypted on the server, it never leaves it) and a certificate request; you upload it to ARCA and bring the certificate back.",
      aliasLabel: "Certificate name (alias)",
      aliasHint:
        "This is how you will see it in ARCA. Letters, numbers and hyphens only.",
      generate: "Generate certificate request",
      regenerate: "Generate a new request",
      downloadCsr: "Download request (.csr)",
      copyCsr: "Copy",
      copied: "Copied",
      csrReady: "Request generated on {date}",
      uploadTitle: "Upload the ARCA certificate",
      uploadHint:
        "The .crt file you downloaded from ARCA (or paste its content).",
      chooseFile: "Choose .crt file",
      pasteHere: "-----BEGIN CERTIFICATE-----",
      upload: "Save certificate",
      installed: "Certificate installed",
      alias: "Alias",
      subject: "Holder",
      issuer: "Issued by",
      validTo: "Expires",
      daysLeft: "{days} days left",
      expired: "expired",
      replace: "Replace certificate",
      remove: "Remove certificate",
      haveOwn: "I already have a certificate and key",
      haveOwnHint:
        "If your accountant already generated a certificate for web-service invoicing, upload the .crt and its private key (.key, without password).",
      keyFile: "Choose .key file",
      uploadPair: "Save certificate and key",
      howToTitle: "How to get the certificate in ARCA",
      howToHomo: [
        "Log in to arca.gob.ar with your tax password (clave fiscal).",
        "Open «WSASS - Autogestión Certificados Homologación» (if missing, add it from «Administrador de Relaciones de Clave Fiscal»).",
        "Choose «Nuevo certificado», enter the alias {alias} and paste the request (.csr) content.",
        "Copy the certificate shown, save it as .crt and upload it below.",
      ],
      howToProd: [
        "Log in to arca.gob.ar with your tax password (level 3 or higher).",
        "Open «Administración de Certificados Digitales» (if missing, add it from «Administrador de Relaciones de Clave Fiscal»).",
        "Choose «Agregar alias», enter {alias} and upload the request (.csr) you downloaded.",
        "Open the alias, download the certificate (.crt) and upload it below.",
      ],
      confirmReplaceTitle: "Replace the certificate?",
      confirmReplaceText:
        "A new key is generated and the current certificate stops working. You will need to request another one in ARCA.",
      confirmRemoveTitle: "Remove the certificate?",
      confirmRemoveText:
        "The key and certificate of this environment are deleted. The app stops connecting to ARCA.",
    },
    authorize: {
      intro:
        "Two more steps inside ARCA: authorize the certificate to invoice and have the web-services point of sale.",
      serviceTitle: "Authorize the certificate",
      serviceHomo: [
        "In «WSASS - Autogestión Certificados Homologación», choose «Crear autorización a servicio».",
        "Choose the certificate {alias}, your CUIT as represented and the service {services}.",
      ],
      serviceProd: [
        "Open «Administrador de Relaciones de Clave Fiscal» and choose «Nueva relación».",
        "Search ARCA → WebServices and choose {services}.",
        "As representative, choose the fiscal computer {alias} and confirm.",
      ],
      serviceDone: "I authorized the service",
      pvTitle: "Web-services point of sale",
      pvHomo:
        "In testing you don't need to create the point of sale: ARCA accepts any number.",
      pvProd: [
        "Open «Administración de puntos de venta y domicilios» and choose «Agregar».",
        "Number {numero}, system «{sistema}».",
      ],
      pvProdExport:
        "For exports, another point of sale: number {numero}, system «Comprobantes de Exportación - Web Services».",
      pvSistemaRi: "RECE para aplicativo y web services",
      pvSistemaMono: "Factura Electrónica - Monotributo - Web Services",
      pvDone: "I have the point of sale",
      wsfeName: "Facturación Electrónica (wsfe)",
      wsfexName: "Factura Electrónica de Exportación (wsfex)",
      and: "and",
      noPvYet: "not set",
    },
    sync: {
      intro:
        "We test the connection end to end without issuing anything: ARCA servers, login with the certificate, point of sale and last authorized number.",
      run: "Sync with ARCA",
      running: "Querying ARCA…",
      lastSync: "Last sync: {date}",
      never: "Not synced yet in this environment.",
      ok: "All good: the app is connected to ARCA.",
      failed: "Some steps need attention.",
      puntosVenta: "Points of sale in ARCA",
      ultimos: "Last authorized document",
      noPuntosVenta: "ARCA returned no web-services points of sale.",
      numero: "Number",
      tipo: "Type",
      estado: "Status",
      activo: "Active",
      bloqueado: "Blocked",
      baja: "Closed",
      service: "Service",
      cbte: "Document",
      ultimo: "Last number",
      stepLabels: {
        data: "Tax details",
        certificate: "Certificate",
        servers: "ARCA servers",
        auth: "Login with certificate",
        puntoVenta: "Point of sale",
        ultimo: "Numbering",
      },
      serviceNames: {
        wsfe: "Domestic",
        wsfex: "Export",
      },
    },
  },
};
